import {Log} from '@aboutyou/mlm';
import {useLocalStorage_DEPRECATED} from '@aboutyou/storage';
import {atobUnescape, btoaEscape} from '@aboutyou/utils';
import {AuthMedium} from '../../types';

const LAST_SEEN_USER_KEY = 'ay-last-user';

export interface LastSeenUser {
  name?: string | null;
  email?: string | null;
  logOn?: number | null; // timestamp
  loginType?: AuthMedium | null;
}

const defaultLastSeenUser: LastSeenUser = {
  name: null,
  email: null,
  logOn: null,
  loginType: null,
};

export const useSavedUser = () => {
  const encodedUser = btoaEscape(JSON.stringify(defaultLastSeenUser));

  // eslint-disable-next-line no-restricted-syntax
  const [state, put] = useLocalStorage_DEPRECATED<string>({
    key: LAST_SEEN_USER_KEY,
    defaultValue: encodedUser,
  });

  let decodedUser;

  try {
    if (state) {
      decodedUser = JSON.parse(atobUnescape(state)) as LastSeenUser;
    }
  } catch (e) {
    Log.error('@aboutyou/logic-components', 'Last saved user failed to parse', {
      error: e,
    });
    put(undefined);
  }

  const hasSavedUser =
    !!decodedUser?.loginType && !!decodedUser.name && !!decodedUser.email;

  const resetSavedUser = () => {
    put(encodedUser);
  };

  return {
    ...decodedUser,
    encodedUser: state,
    hasSavedUser,
    resetSavedUser,
    saveUser: (name: string, email: string, loginType: AuthMedium) => {
      const encoded = btoaEscape(
        JSON.stringify({
          name,
          email,
          loginType,
          logOn: Date.now(),
        }),
      );
      put(encoded);
    },
  };
};
